<section *ngIf="detail.crawl; else noCrawl" class="first">
  <div><span class="bucket" [class]="'b-' + detail.crawl.bucket">{{ detail.crawl.bucket }}</span> score {{ detail.crawl.score }} · {{ detail.crawl.venueCount | number }} venues · {{ detail.crawl.landmarkCount }} landmarks · {{ detail.crawl.imageCount }} images</div>
  <div class="text-sm text-600" *ngIf="crawlFacts(detail.crawl) as facts">{{ facts }}</div>
  <div *ngIf="detail.types?.length" class="mt-2">
    <div class="sub">Venues by what they suit</div>
    <span *ngFor="let t of detail.types" class="pill">{{ t.key }} {{ t.n | number }}</span>
  </div>
  <div *ngIf="detail.topKinds?.length" class="mt-2">
    <div class="sub">Most common kinds</div>
    <span *ngFor="let t of detail.topKinds" class="pill">{{ t.key }} {{ t.n | number }}</span>
  </div>
</section>
<ng-template #noCrawl>
  <section class="first"><div class="text-600 text-sm">{{ detail.dataset ? "Nothing: this suburb isn't in the crawl." : 'No crawl dataset is loaded here.' }}</div></section>
</ng-template>

<section *ngIf="detail.crawl?.landmarks?.length">
  <div class="lbl">Landmarks</div>
  <ul class="plain">
    <li *ngFor="let l of detail.crawl.landmarks">
      <a *ngIf="safeUrl(l.url) as href; else plainName" [href]="href" target="_blank" rel="noopener noreferrer">{{ l.name }}</a>
      <ng-template #plainName>{{ l.name }}</ng-template>
      <span class="text-500 text-xs"> {{ l.kinds?.join(', ') }}</span>
    </li>
  </ul>
</section>

<section *ngIf="detail.crawl?.images?.length">
  <div class="lbl">Images ({{ detail.crawl.imageCount }})</div>
  <ul class="plain">
    <li *ngFor="let i of detail.crawl.images">
      <a *ngIf="safeUrl(i.url) as href; else plainTitle" [href]="href" target="_blank" rel="noopener noreferrer">{{ i.title || 'image' }}</a>
      <ng-template #plainTitle>{{ i.title || 'image' }}</ng-template>
      <span class="text-500 text-xs"> {{ i.license }}</span>
    </li>
  </ul>
</section>

<section *ngIf="detail.venues?.length">
  <div class="lbl">Venues in the crawl ({{ detail.venuesShown }}{{ detail.crawl?.venueCount > detail.venuesShown ? ' of ' + (detail.crawl.venueCount | number) : '' }})</div>
  <div class="mb-2"><span *ngFor="let k of detail.venueKinds" class="pill">{{ k.key }} {{ k.n }}</span></div>
  <ul class="plain venues">
    <li *ngFor="let v of detail.venues"><span>{{ v.name || '(unnamed)' }}</span><span class="text-500 text-xs"> {{ v.kind }}</span></li>
  </ul>
</section>

<section>
  <div class="lbl">Changes</div>
  <div *ngIf="!detail.changes?.length" class="text-600 text-sm">None recorded.</div>
  <ul class="plain">
    <li *ngFor="let c of detail.changes" class="text-sm">
      <span class="text-600">{{ c.at | date: 'd MMM y, h:mm a' }}</span> · {{ c.field }}: {{ changeText(c) }}
      <span class="text-500"> ({{ c.source }}{{ c.by ? ', ' + c.by : '' }})</span>
    </li>
  </ul>
</section>
